import React, { useEffect, useState } from 'react'
import UsersTable from '../../components/Tables/UsersTable';
import { useAllUsers } from '../../graphql';
import { FetchUsers, checkedItems } from '../../types';
import LoadingWidget from '../../components/LoadingWidget/LoadingWidget';
import SuccessAlert from '../../components/Alerts/SuccessAlert';
import FailAlert from '../../components/Alerts/FailAlert';
import { Link } from 'react-router-dom';
import DeleteConfirmPopup from './DeleteConfirmPopup';
import { IoArrowBackSharp, IoArrowForward } from 'react-icons/io5';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { t } from 'i18next';

const Users = ({ direction }: { direction: string }) => {
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [fail, setFail] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  // The state that contains Fetched Users, i didn't use dataAllUsers from useAllUsers beacuse i couldn't modify it to contain filtered result
  const [Users, setUsers] = useState<FetchUsers>();

  // i had to use a main state for control loading because of ui issues
  const [initialLoading, setInitialLoading] = useState(true);

  const [deleteConfirmPopup, setDeleteConfPopup] = useState(false);

  // This state contain the user id of that will be added, it could be also use for delete
  const [selectedUserId, setSelectedUserId] = useState("");

  const [allUsers, { loading, data: dataAllUsers }] = useAllUsers();

  useEffect(() => {
    (async () => {
      await allUsers();

      setInitialLoading(false)
    })()
  }, [allUsers]);

  const [startingIndex, setStartingIndex] = useState(0);

  useEffect(() => {
    dataAllUsers !== undefined && setUsers(dataAllUsers)
  }, [dataAllUsers]);

  // Search functionality
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState<any>([]);

  useEffect(() => {
    const filtered = dataAllUsers?.usersAllStores.filter((item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    setSearchResult(filtered);
  }, [searchQuery, dataAllUsers]);

  const [checkedItems, setCheckedItems] = useState<checkedItems[]>([]);

  return (
    <section className='my-4 mx-7'>
      {success && <SuccessAlert success={success} setSuccess={setSuccess} successMsg={successMsg} />}

      {fail && <FailAlert fail={fail} setFail={setFail} failMsg={failMsg} />}

      {deleteConfirmPopup && <DeleteConfirmPopup checkedItems={checkedItems} selectedIdForDelete={selectedUserId} setDeleteConfPopup={setDeleteConfPopup} setSuccessMsg={setSuccessMsg} setSuccess={setSuccess} />}

      <div className='flex flex-col-reverse md:flex-row md:justify-between md:items-center'>
        <div>
          <h3 className='text-2xl font-semibold'>{t('users')}</h3>
        </div>
        <div>
          <Breadcrumbs />
        </div>
      </div>

      {initialLoading || loading ?
        <LoadingWidget />
        :
        <div className='p-2 mt-3 bg-white rounded-md'>
          <div>
            <div className='my-2 md:flex md:justify-between'>
              <div className="relative flex items-center w-full h-12 overflow-hidden bg-white border rounded-lg md:w-2/6">
                <div className="grid w-12 h-full text-gray-300 place-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>

                <input value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="w-full h-full pr-2 text-sm text-gray-700 outline-none" type="text" id="search" placeholder={t('searchSomething')} />
              </div>

              <div>
                <Link to="/users/create" className='inline-flex items-center justify-center w-full px-4 py-2.5 overflow-hidden text-sm text-white transition-colors duration-300 bg-primary rounded-lg shadow sm:w-auto my-2 md:my-0 hover:bg-primaryHover'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 2H8c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8 16V4h12l.002 12H8z"></path>
                    <path d="M4 8H2v12c0 1.103.897 2 2 2h12v-2H4V8zm11-2h-2v3h-3v2h3v3h2v-3h3V9h-3z"></path>
                  </svg>

                  <span className="mx-2">
                    {t('Add User')}
                  </span>
                </Link>
              </div>
            </div>
          </div>

          <div className='h-full pt-2 overflow-x-scroll'>
            <UsersTable checkedItems={checkedItems} setCheckedItems={setCheckedItems} direction={direction} allUsers={Users} setSelectedUserId={setSelectedUserId} searchQuery={searchQuery} startingIndex={startingIndex} searchResult={searchResult} setDeleteConfirmPopup={setDeleteConfPopup} />
          </div>

          {searchQuery !== "" &&
            searchResult !== undefined &&
            searchResult.length === 0 &&
            <div className='flex w-full p-2 mt-2 text-red-600 bg-red-200'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"></path>
                <path d="M11 7h2v7h-2zm0 8h2v2h-2z"></path>
              </svg>
              <span className='px-2'>{t('notMatch')}</span>
            </div>
          }

          {Users !== undefined &&
            Users?.usersAllStores.filter(user => user.store !== null).length === 0 &&
            <div className='flex w-full p-2 mt-2 text-red-600 bg-red-200'>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.953 2C6.465 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.493 2 11.953 2zM12 20c-4.411 0-8-3.589-8-8s3.567-8 7.953-8C16.391 4 20 7.589 20 12s-3.589 8-8 8z"></path>
                <path d="M11 7h2v7h-2zm0 8h2v2h-2z"></path>
              </svg>
              <span className='px-2'>{t('No Users to show')}</span>
            </div>
          }

          <div className="flex justify-end gap-1.5 text-gray-500 py-4">
            <span className="font-medium text-gray-700">{startingIndex} - {startingIndex + 10}</span>
            <span>{t('of')} {Users?.usersAllStores.length} {t('records')}</span>
          </div>

          <div dir={"ltr"} className='flex items-center justify-between'>
            {Users !== undefined &&
              startingIndex !== 0 &&
              <div className="gap-1.5 text-gray-500 py-2">
                <button onClick={() => setStartingIndex(startingIndex - 10)} className='inline-flex items-center justify-center w-full px-4 py-2.5 overflow-hidden text-sm text-white transition-colors duration-300 bg-primary rounded-lg shadow sm:w-auto my-2 md:my-0 hover:bg-primaryHover'>
                  <IoArrowBackSharp size={18} />
                  <span className="mx-2">
                    {t('prev')}
                  </span>
                </button>
              </div>
            }

            {Users !== undefined &&
              startingIndex + 10 < Users?.usersAllStores.length &&
              <div className="ml-auto gap-1.5 text-gray-500 py-2">
                <button onClick={() => setStartingIndex(startingIndex + 10)} className='inline-flex items-center justify-center w-full px-4 py-2.5 overflow-hidden text-sm text-white transition-colors duration-300 bg-primary rounded-lg shadow sm:w-auto my-2 md:my-0 hover:bg-primaryHover'>
                  <IoArrowForward size={18} />
                  <span className="mx-2">
                    {t('next')}
                  </span>
                </button>
              </div>
            }
          </div>
        </div>
      }
    </section>
  )
}

export default Users